import { Component } from '@angular/core';

@Component({
  selector: 'coaches',
  templateUrl: 'coaches.html'
})

export class CoachesComponent {
  private roleId: string = "396FD4C0-C4AE-4529-809E-B4B22C23F9D0";

  constructor() { }
}
